import { useTranslation } from 'react-i18next'
import { Button, Dialog, Typogaphy } from 'vnetwork-ui'

interface DraftRestoreDialogProps {
    open: boolean
    onAccept: () => void
    onDecline: () => void
}

const DraftRestoreDialog = ({
    open,
    onAccept,
    onDecline,
}: DraftRestoreDialogProps) => {
    const { t } = useTranslation('asset')

    if (!open) return null

    return (
        <Dialog open title={t('draft_restore.title')} onClose={onDecline}>
            <Typogaphy>{t('draft_restore.desc')}</Typogaphy>
            <div className="flex justify-end gap-2 mt-4">
                <Button
                    variant="outlined"
                    onClick={onDecline}
                    className="min-w-[100px]"
                >
                    {t('draft_restore.discard')}
                </Button>
                <Button
                    variant="contained"
                    onClick={onAccept}
                    className="min-w-[150px]"
                >
                    {t('draft_restore.restore')}
                </Button>
            </div>
        </Dialog>
    )
}

export default DraftRestoreDialog
